import { RootState } from "../../../../store";
import { resourceExplorerStateSelector } from "../../resourceExplorerStateSelector";

export const resourceExplorerCsvDataHashSelector = (state: RootState) => {
  return resourceExplorerStateSelector(state).csvDataHash;
};
